import { useStaticQuery, graphql } from 'gatsby';

export const useBlogLogo = () => {
  return useStaticQuery<Queries.BlogLogoQuery>(graphql`
    query BlogLogo {
      logo: file(absolutePath: { regex: "/evan-library/logo.png/" }) {
        childImageSharp {
          gatsbyImageData(width: 50)
        }
      }
      openGraphImage: file(absolutePath: { regex: "/evan-library/open-graph.jpg/" }) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH, aspectRatio: 2, transformOptions: { cropFocus: CENTER, fit: COVER })
        }
      }
    }
  `);
};
